(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["conditions-listing"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
        const searchInput = document.getElementById('conditionsSearch');
        const menuItems = document.querySelectorAll('.ConditionsListing__Menu li');
        const gridBlocks = document.querySelectorAll('.ConditionsListing__Block');

        searchInput.addEventListener('input', (e) => {
            const searchTerm = e.target.value.toLowerCase().trim();

            // Filter menu items
            menuItems.forEach(item => {
                const title = item.getAttribute('data-condition-title');
                if (title.includes(searchTerm)) {
                    item.classList.remove('hidden');
                } else {
                    item.classList.add('hidden');
                }
            });

            // Filter grid blocks
            gridBlocks.forEach(block => {
                const title = block.getAttribute('data-condition-title');
                if (title.includes(searchTerm)) {
                    block.classList.remove('hidden');
                } else {
                    block.classList.add('hidden');
                }
            });
        });
    });

  } catch(e) { console.error(e); }
})();
})();
